module.exports = __webpack_public_path__ + "static/img/aqzs56.395acbdf.jpg";